import { createWebDevelopmentStage } from "./services-stages/webDevelopmentStage.js";
import { createAiAgenticStage } from "./services-stages/aiAgenticStage.js";
import { createAppDevelopmentStage } from "./services-stages/appDevelopmentStage.js";
import { createUiUxDesignStage } from "./services-stages/uiUxDesignStage.js";
import { createCyberSecurityStage } from "./services-stages/cyberSecurityStage.js";
import { createStaffAugmentationStage } from "./services-stages/staffAugmentationStage.js";

const STAGE_BUILDERS = {
  "web-development": createWebDevelopmentStage,
  "ai-agentic": createAiAgenticStage,
  "app-development": createAppDevelopmentStage,
  "ui-ux-design": createUiUxDesignStage,
  "cyber-security": createCyberSecurityStage,
  "staff-augmentation": createStaffAugmentationStage,
};

/** Pick a stage visual by service slug. Falls back to web development for now. */
export function createServicesStage(slug = "web-development") {
  const build = STAGE_BUILDERS[slug] || createWebDevelopmentStage;
  return build();
}
